import { Routes, Route } from "react-router-dom";

import HospitalityHome from "./page/hospitality/HospitalityHome";
import HospitalityProvider from "./page/hospitality/HospitalityProvider";
import HospitalityCategory from "./page/hospitality/HospitalityCategory";
import HospitalityLogin from "./page/auth/HospitalityLogin";
import HospitalityRegister from "./page/auth/HospitalityRegister";

import HospitalityHeader from "./components/HospitalityHeader";
import HospitalityFooter from "./components/HospitalityFooter";
import AdminPanel from "./page/AdminPanel";


export default function App() {
  return (
    <>
      <HospitalityHeader />
      <main>
        <Routes>
          <Route path="/hospitality" element={<HospitalityHome />} />
          <Route path="/hospitality/category/:category" element={<HospitalityCategory />}/>
          <Route path="/hospitality/provider/:id" element={<HospitalityProvider />} />
          <Route path="/hospitality/login" element={<HospitalityLogin />} />
          <Route path="/hospitality/register" element={<HospitalityRegister />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="*" element={<HospitalityHome />} />
        </Routes>
      </main>
      <HospitalityFooter />
    </>
  );
}
